export default "__VITE_ASSET__8d0bd541__"